export const iconFontAwesomeTravelHotelRoadSpikes = (
	<i className="fa-solid fa-road-spikes"></i>
);
